var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStartCandidateJourneyIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_134_1",
    "data-name": "Component 134 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 243.869,
    height: 243.417,
    viewBox: "0 0 243.869 243.417",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1725",
    "data-name": "Rectangle 1725",
    width: 239.953,
    height: 235.365,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1677",
    "data-name": "Rectangle 1677",
    width: 49.619,
    height: 12.38,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1678",
    "data-name": "Rectangle 1678",
    width: 7.373,
    height: 5.5,
    fill: "#b2caff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9505",
    "data-name": "Group 9505",
    transform: "translate(0 -0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9504",
    "data-name": "Group 9504",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9443",
    "data-name": "Group 9443",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9442",
    "data-name": "Group 9442",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10539",
    "data-name": "Path 10539",
    d: "M801.54,13.433a24.682,24.682,0,0,0,3.028-.5,14.3,14.3,0,0,1,3.437-.494c1.815.117,4.791.965,6.056,3.139,1.577,2.709,5.671,1.68,2.322,13.3-3.791,13.155-10.885,10.05-11.015,9.784s-4.728-10-4.728-10-3.339,4.424-3.3,4.244-8.034-18.163,4.2-19.48",
    transform: "translate(-585.985 -9.51)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10540",
    "data-name": "Path 10540",
    d: "M621.032,142.37c.048-.866,3.98.041,4.492-.644s-4.306-2.741-4.2-3.485c.191-1.37,5.415,1.928,5.543,1.3s-5.091-4.292-4.059-5.03,5.015,4.367,5.451,3.758-4.131-4.414-3.427-5.854c.376-.77,6.981,7.492,8.151,7.471s.642-4.585,1.659-4.81-.056,8.812.378,9.307,9.273,11.86,12.954,14.605c1.067-1.172,7.669-7,8.647-8.117,1.631,2.594,4.16,4.057,5.924,6.536-3.509,3.613-13.829,11.815-15.255,11.863-4.343.144-13.658-17.437-15.655-20.612s-3.886-3.193-5.537-4.618-5.109-.808-5.061-1.673",
    transform: "translate(-453.104 -101.244)",
    fill: "#ed985f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10541",
    "data-name": "Path 10541",
    d: "M759.339,178.4s12.389-8.468,15.141-13.546-7.358-12.285-11.974-10.087c-5.116,2.436-11.695,14.862-11.695,14.862Z",
    transform: "translate(-552.368 -118.062)",
    fill: "#222949"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10542",
    "data-name": "Path 10542",
    d: "M728.34,930.675s.438,7.872.44,7.888c.161,1,.794,3.468.794,4.377,0,3.413-14.909-2.9-11.567-4.41.3-.137,1.887-1.172,1.986-2.334.154-1.79.542-5.411.542-5.411Z",
    transform: "translate(-526.903 -711.843)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10543",
    "data-name": "Path 10543",
    d: "M679.509,964.308a26.885,26.885,0,0,0,5.3,1.951c1.793.261,4.156-1.937,5.424-1.343,1.4.653,1.255,7.088,1.255,7.088s-18.684,1.122-23.962-.611c-2.091-.686,4.828-4.653,11.984-7.085",
    transform: "translate(-488.375 -737.568)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10544",
    "data-name": "Path 10544",
    d: "M868.031,933.888s.438,7.872.44,7.888c.161,1,.794,3.469.794,4.377,0,3.413-14.909-2.9-11.567-4.41.3-.137,2.357-1.945,2.456-3.107.153-1.79.072-4.638.072-4.638Z",
    transform: "translate(-633.748 -714.301)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10545",
    "data-name": "Path 10545",
    d: "M817.59,966.7a52.926,52.926,0,0,0,5.293,1.3c1.793.261,4.156-1.937,5.424-1.343,1.4.653,1.452,6.535,1.452,6.535s-19.975,1.475-24.671.09c-2.11-.622,5.347-4.155,12.5-6.587",
    transform: "translate(-593.604 -739.291)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10546",
    "data-name": "Path 10546",
    d: "M739.123,450.627l-6.3,2.77-13.258,64.495.537,48.35,10.628.252s4.944-42.294,4.944-45.571,22.9-57.358,22.9-57.358Z",
    transform: "translate(-528.465 -344.67)",
    fill: "#628ed3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10547",
    "data-name": "Path 10547",
    d: "M823.445,449.622s4.644,49.691,4.644,58.067,3.765,55.256,3.765,55.256l10.654-.063s.769-14.289,1.911-35.311c.179-3.292-.23-9.936,0-13.344,1.657-24.515,3.554-65.795,2.632-66.766-6.977-7.352-23.605,2.161-23.605,2.161",
    transform: "translate(-607.923 -340.116)",
    fill: "#699dee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10548",
    "data-name": "Path 10548",
    d: "M784.955,148.437s8.35.886,10.4,2.163c2.311,1.438,3.514,7.431,3.514,7.431s-1.319,31.172-.71,38.46c.471,5.638.812,35.642.812,35.642s-28.817.59-39.464-2.665c0,0,3.526-20.194,3.155-24.516s.143-43.962.792-46.783c.589-2.559,1.672-7.161,6.543-8.691s14.956-1.041,14.956-1.041",
    transform: "translate(-559.02 -113.478)",
    fill: "#040227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10549",
    "data-name": "Path 10549",
    d: "M828.254,111.888l2.709,10.279s-4.939,6.186-8.985,5.448c-3.394-.62-2.913-4.981-2.913-4.981s1.3-6.059.505-8.967,8.683-1.779,8.683-1.779",
    transform: "translate(-604.555 -85.414)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10550",
    "data-name": "Path 10550",
    d: "M821.137,113.667c-.8-2.908,8.683-1.779,8.683-1.779l.225.853a4.761,4.761,0,0,1-.885,1.541,13.178,13.178,0,0,1-7.867,3.917,14.149,14.149,0,0,0-.155-4.532",
    transform: "translate(-606.121 -85.414)",
    fill: "#ed985f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10551",
    "data-name": "Path 10551",
    d: "M118.684,893.893s-2.726,2.661-2.788,3.637-.242,11.436.871,12.412,4.382,1.669,3.331,2.767c-.794.83-6.906.653-10.956.43-1.182-.065-2.665-9.5-3.134-10.886-.68-2.014-2.334-6.55-1.716-7.953a11.8,11.8,0,0,1,3.774-3.4,18.565,18.565,0,0,0,4.18-4.452Z",
    transform: "translate(-57.762 -678.015)",
    fill: "#e49963"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10552",
    "data-name": "Path 10552",
    d: "M275.2,943.983s-2.44,6.893-2.443,6.91c-.181,1.092-.9,3.79-.9,4.783,0,3.729,16.819-3.166,13.05-4.819a3.982,3.982,0,0,1-1.524-2.614c-.173-1.956,1.417-4.409,1.417-4.409Z",
    transform: "translate(-186.032 -721.909)",
    fill: "#e49963"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10553",
    "data-name": "Path 10553",
    d: "M307.573,398.6s1.226,12.356,1.226,12.541c0,19.988,3.962,59.032,3.209,62.79-1.838,9.166-21.623,55.924-21.623,55.924l-10.693-1.278L293.626,472.6,288.5,450.062l-7.256-44.541Z",
    transform: "translate(-192.023 -304.878)",
    fill: "#262d4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10554",
    "data-name": "Path 10554",
    d: "M153.179,415.267l-2.029,11.711-5.49,48.2-20.906,47.107s2.94,6.855,7.279,7.817l33.273-48.365,20.669-61.887-.726-13.749Z",
    transform: "translate(-73.517 -310.613)",
    fill: "#040227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10555",
    "data-name": "Path 10555",
    d: "M103.784,905.1s6.284,17.693,8.743,18.547c.653.227,3.787.8,4.378,2.188a5.994,5.994,0,0,1,0,1.812h-13.1s-1.657-7.8-2.311-11.221c0,0-3.467-8.369-3.082-9.13s5.369-2.2,5.369-2.2",
    transform: "translate(-53.347 -692.28)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10556",
    "data-name": "Path 10556",
    d: "M267.789,979.634l1.926-6.084s4.045,1.711,6.067,1.426a61.3,61.3,0,0,0,5.971-1.426c8.073,2.657,14.686,3.947,13.483,6.084Z",
    transform: "translate(-182.919 -744.637)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10557",
    "data-name": "Path 10557",
    d: "M588.925,260.081l-1.1.665a8.4,8.4,0,0,1-1.347.957c-.276.065-7.815-.1-7.815-.1s-.027,2.508.022,2.508,3.964,3.191,3.964,3.191l.835.382,5.136-1.534,4.689-.588s3.327-.386,3.327-.467a21.56,21.56,0,0,0-.227-2.839c-.13-.13-2.012-2.061-2.012-2.061s-1.444-.324-1.493-.324-1.445-.276-1.493-.292-2.239.324-2.239.324Z",
    transform: "translate(-420.689 -198.542)",
    fill: "#e49963"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10558",
    "data-name": "Path 10558",
    d: "M615.6,265.182a12.6,12.6,0,0,0-2.336.519c-.811.324-7.237,5.192-7.237,5.192s-.86.47-1.314.1a1.034,1.034,0,0,1-.422-.811s-.763.422-1.282.13a.872.872,0,0,1-.438-1.022,1.464,1.464,0,0,1-1.185-.162c-.438-.373-.211-1.33-.211-1.33s-1.379.844-1.915.276-.308-1.168.227-1.623,3.716-2.564,4.089-2.807,1.428-1.363,1.752-1.509,1.12-.584,1.12-.584,1.331.146,1.412.195.454.974,1.12,1.217a1.7,1.7,0,0,0,1.477-.195,1.232,1.232,0,0,0,.016-.5,11.477,11.477,0,0,1-.633-1.477c-.114-.568-.26-.73-.471-.86s-1.363-.471-1.931-.7-2.953.438-2.953.438l-1.136.487s.211-.841.925-.972,1.606-.326,2.109-.375a22.12,22.12,0,0,1,2.207.341,8.659,8.659,0,0,1,2.142.341,25.255,25.255,0,0,0,4.462-.032s1.574,4.267.406,5.728",
    transform: "translate(-436.221 -197.948)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10559",
    "data-name": "Path 10559",
    d: "M664.174,218.117c1.529-.035,19.184-.184,25.816-.239a7.312,7.312,0,0,0,4.461-1.566L709.2,204.7l8.954,9.389-18.021,12.456c-1.225.885-8.1,1.652-9.6,1.5-6.966-.705-24.676-4.253-26.45-4.011Z",
    transform: "translate(-486.033 -156.571)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10560",
    "data-name": "Path 10560",
    d: "M437.182,224.618c-1.529-.034-20.127-.3-26.759-.36a7.312,7.312,0,0,1-4.461-1.566l-14.753-11.608-6.46,7.445,18.315,13.23A6.166,6.166,0,0,0,407.3,232.9c6.966-.7,26.046-2.571,27.819-2.329Z",
    transform: "translate(-272.378 -161.451)",
    fill: "#e49963"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10561",
    "data-name": "Path 10561",
    d: "M811.486,172.813s12.35-12.991,16.817-16.27,10.132-.512,10.418,5.157c.416,8.26-15.958,23.041-15.958,23.041Z",
    transform: "translate(-598.776 -118.661)",
    fill: "#222949"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10562",
    "data-name": "Path 10562",
    d: "M347.115,172.823s-12.35-12.991-16.817-16.27-13.453-.492-12.74,5.139c.727,5.745,20.9,20.286,20.9,20.286Z",
    transform: "translate(-220.955 -118.671)",
    fill: "#4a75cb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10563",
    "data-name": "Path 10563",
    d: "M264.947,164.661c.288,1.989,8.253,65.631,8.253,65.631a73.8,73.8,0,0,1-44.371.3s3.65-45.682,2.668-50.852c-.65-3.42-.045-26.474,2.172-27.11a40.486,40.486,0,0,1,8.245-1.728c3.034-.315,14.821-.5,16.93.211a26.856,26.856,0,0,1,6.1,13.546",
    transform: "translate(-153.12 -115.209)",
    fill: "#699dee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10564",
    "data-name": "Path 10564",
    d: "M292.644,102.326,290.8,113.59s6.744,14.333,10.774,13.127c3.381-1.012,1.3-13.323,1.3-13.323s-1.843-6.611-1.29-9.919-8.943-1.149-8.943-1.149",
    transform: "translate(-200.521 -77.736)",
    fill: "#e49963"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10565",
    "data-name": "Path 10565",
    d: "M307.081,103.475c.553-3.308-8.943-1.149-8.943-1.149l-.153.969a5.348,5.348,0,0,0,1.03,1.629,12.749,12.749,0,0,0,8.3,3.6,17.314,17.314,0,0,1-.236-5.052",
    transform: "translate(-206.015 -77.736)",
    fill: "#d68d5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10566",
    "data-name": "Path 10566",
    d: "M289.621,22.4c-.268-.093-2.151,13.308,1.422,17s10.535,4.894,13.032,1.99c2.762-3.212,2.623-17.616-2.932-21.409S289.621,22.4,289.621,22.4",
    transform: "translate(-199.056 -14.341)",
    fill: "#e49963"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10567",
    "data-name": "Path 10567",
    d: "M268.581,2.894c-1.949.221-4.6,1.254-7.336,5.6-3.364,5.343-.88,11.262,3.037,14.167s3.847,6.23,3.847,6.23l.635-1.706a9.335,9.335,0,0,0,.491-4.088,7.732,7.732,0,0,0-.633-2.457c-.942-1.939,2.023-3.228,2.855-4.842.641-1.242.671-4.085,1.68-6.139l1.2-1.568s2.78-2.074,5.5-1.489-.621-12.138-11.278-3.708",
    transform: "translate(-176.706 0.001)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10568",
    "data-name": "Path 10568",
    d: "M297.515,67.8c.028,1.635-.747,2.974-1.731,2.99s-1.805-1.3-1.834-2.932.747-2.974,1.731-2.99,1.805,1.3,1.834,2.931",
    transform: "translate(-202.929 -49.612)",
    fill: "#e49963"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10569",
    "data-name": "Path 10569",
    d: "M334.58,90.442l-5.9.6a2.594,2.594,0,0,0,2.968,2.039c3.175-.231,2.935-2.64,2.935-2.64",
    transform: "translate(-229.491 -69.176)",
    fill: "#f7f7f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10572",
    "data-name": "Path 10572",
    d: "M814.574,36.1a6.51,6.51,0,0,0-8.742,4.809,49.447,49.447,0,0,0-.817,6.232c-.367,5.691,2.316,11.367,4.894,11.483s9.874-3.249,10.506-11.323c.39-4.985-1.884-9.631-5.841-11.2",
    transform: "translate(-593.8 -27.268)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10573",
    "data-name": "Path 10573",
    d: "M862.405,80.438a1.9,1.9,0,1,0,1.96-2.191,2.1,2.1,0,0,0-1.96,2.191",
    transform: "translate(-637.72 -59.847)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10574",
    "data-name": "Path 10574",
    d: "M823.341,39.747s-3.166.082-3.853-2.095-3.749-7.223-9.193-6.616,5.384-3.214,5.789-3.125,5.273,1.131,5.273,1.131,3.065,3.91,3.125,4.279.324,4.3.324,4.3Z",
    transform: "translate(-596.696 -21.348)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10575",
    "data-name": "Path 10575",
    d: "M821.3,106.809l-5.692-.164a2.49,2.49,0,0,0,2.567,2.317c3.05.176,3.125-2.153,3.125-2.153",
    transform: "translate(-601.931 -81.569)",
    fill: "#f7f7f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10416",
    "data-name": "Path 10416",
    d: "M48.413,22.1H1.207A1.207,1.207,0,0,1,0,20.895V1.207A1.207,1.207,0,0,1,1.207,0H48.413A1.207,1.207,0,0,1,49.62,1.207V20.895A1.207,1.207,0,0,1,48.413,22.1",
    transform: "matrix(0.809, 0.588, -0.588, 0.809, 30.786, 112.142)",
    fill: "#040227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10417",
    "data-name": "Path 10417",
    d: "M16.564,10.66H3.684A3.688,3.688,0,0,1,0,6.976V3.684A3.688,3.688,0,0,1,3.684,0h12.88a3.688,3.688,0,0,1,3.684,3.684V6.976a3.688,3.688,0,0,1-3.684,3.684M3.684,2.689a1,1,0,0,0-.995.995V6.976a1,1,0,0,0,.995.995h12.88a1,1,0,0,0,.995-.995V3.684a1,1,0,0,0-.995-.995Z",
    transform: "matrix(0.809, 0.588, -0.588, 0.809, 51.005, 109.299)",
    fill: "#b2caff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9321",
    "data-name": "Group 9321",
    transform: "matrix(0.809, 0.588, -0.588, 0.809, 30.789, 112.142)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9320",
    "data-name": "Group 9320",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10418",
    "data-name": "Path 10418",
    d: "M48.408,0H1.206A1.2,1.2,0,0,0,0,1.206V7.522l24.578,4.835a1.131,1.131,0,0,0,.458,0L49.619,7.522V1.206A1.208,1.208,0,0,0,48.408,0",
    transform: "translate(0 0)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_10419",
    "data-name": "Path 10419",
    d: "M50.678,14.264,26.049,19.109a1.2,1.2,0,0,1-.46,0L.961,14.264A1.191,1.191,0,0,1,0,13.1V1.191A1.19,1.19,0,0,1,1.19,0H50.448a1.191,1.191,0,0,1,1.19,1.191V13.1a1.19,1.19,0,0,1-.961,1.168",
    transform: "matrix(0.809, 0.588, -0.588, 0.809, 34.72, 105.01)",
    fill: "#040227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10420",
    "data-name": "Path 10420",
    d: "M6.231,5.5H1.141A1.144,1.144,0,0,1,0,4.358V1.141A1.144,1.144,0,0,1,1.141,0H6.231A1.145,1.145,0,0,1,7.373,1.141V4.358A1.145,1.145,0,0,1,6.231,5.5",
    transform: "matrix(0.809, 0.588, -0.588, 0.809, 43.302, 130.854)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9324",
    "data-name": "Group 9324",
    transform: "matrix(0.809, 0.588, -0.588, 0.809, 43.303, 130.853)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9323",
    "data-name": "Group 9323",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10421",
    "data-name": "Path 10421",
    d: "M6.231,5.5H1.141A1.144,1.144,0,0,1,0,4.358V1.141A1.144,1.144,0,0,1,1.141,0H6.231A1.145,1.145,0,0,1,7.373,1.141V4.358A1.145,1.145,0,0,1,6.231,5.5",
    transform: "translate(0 0.001)",
    fill: "#b2caff"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1679",
    "data-name": "Rectangle 1679",
    width: 157.793,
    height: 197.524,
    transform: "matrix(0.809, 0.588, -0.588, 0.809, 14.326, 30.882)",
    fill: "none"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_10576",
    "data-name": "Path 10576",
    d: "M134.528,266.584a1.579,1.579,0,0,1-.006-.368c.39-3.959,3.677-37.2,4.23-38.614.5-1.276,15.241-22.36,15.241-22.36l7.246,9.871-14.177,18.911c-.318,1.2-5.433,23.642-5.433,23.642s-1.048,4.09-1.518,6.54c.214.59.425,1.148.611,1.605a14.768,14.768,0,0,0,1.527,2.455,16.821,16.821,0,0,1,1.811,3.2c.15.577.421,1.777.574,2.5s.363,1.567.4,1.96a3.793,3.793,0,0,0,.458,1.053.633.633,0,0,1-.746.913c-.515-.171-.916-.838-1.163-1.253-.7-1.173-1.07-3.314-1.243-3.2s-1.029,3.208-1.263,3.559a.892.892,0,0,1-1.609-.345c-.053-.279-.186-.263-.315-.156a1.136,1.136,0,0,1-.941.288c-.8-.1-.658-.91-.944-.784a1.05,1.05,0,0,1-1.586-.82c.009-.157-.062-.247-.228-.217-.544.1-1.409.2-1.42-1.633s.838-3.887.585-6.066c-.016-.137-.06-.473-.089-.684",
    transform: "translate(-80.613 -156.982)",
    fill: "#e49963"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10577",
    "data-name": "Path 10577",
    d: "M169.945,183.238l12.592,8.454s7.1-10.561,10.907-14.321c4.773-4.71-1.738-19.139-4.813-18.323-6.878,1.826-18.686,24.189-18.686,24.189",
    transform: "translate(-108.082 -121.626)",
    fill: "#699dee"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_10612",
    "data-name": "Path 10612",
    d: "M208.645,352.668c0,4.448-46.707,8.052-104.322,8.052S0,357.116,0,352.668s46.707-8.052,104.322-8.052,104.322,3.606,104.322,8.052",
    transform: "translate(35.225 -117.303)",
    fill: "#7586ec",
    opacity: 0.2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartCandidateJourneyIcon);
export default __webpack_public_path__ + "static/media/start-candidate-journey-icon.3f68df9ef2d93bbd0945d5b404ed9dbf.svg";
export { ForwardRef as ReactComponent };